import { render, staticRenderFns } from "./QuickAccountBilling.vue?vue&type=template&id=daaaffa6&scoped=true&"
import script from "./QuickAccountBilling.vue?vue&type=script&lang=js&"
export * from "./QuickAccountBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaaffa6",
  null
  
)

export default component.exports